export enum LegalBasis {
  Consent = "Consent",
  InterestAssessment = "InterestAssessment",
  Agreement = "Agreement"
}
